import { useQuery } from "@tanstack/react-query";
import { menuVisibilityQuery } from "@/lib/shellQueries";

export function useMenuVisibility() {
  const { data: menuVisibilityData, isLoading } = useQuery(menuVisibilityQuery());

  // Convert API data to map
  const menuVisibility = (menuVisibilityData as any)?.reduce((acc: Record<string, boolean>, setting: any) => {
    const key = setting.menuKey || setting.menu_key;
    acc[key] = setting.visible;
    return acc;
  }, {} as Record<string, boolean>) || {};

  // Helper function to check if a menu item is visible
  // Defaults to true when loading or if setting doesn't exist
  const isVisible = (menuKey: string): boolean => {
    if (isLoading) return true; // Show by default while loading
    return menuVisibility[menuKey] !== false;
  };

  return {
    menuVisibility,
    isLoading,
    isVisible,
  };
}
